module.exports = __webpack_public_path__ + "static/media/mine-active.7fca8012.png";